
(function() {
  var result = { translations: { "et": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} p\xE4eva", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}p", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Kv{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, laiend {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "et": "static-7.1179"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1179",
    "ar-eg": "static-7.1179",
    "bg": "static-7.1179",
    "bn": "static-7.1179",
    "ca-es": "static-7.1179",
    "cs": "static-7.1179",
    "da": "static-7.1179",
    "de": "static-7.1179",
    "el": "static-7.1179",
    "en-gb": "static-7.1179",
    "en": "static-7.1179",
    "es-mx": "static-7.1179",
    "es": "static-7.1179",
    "et": "static-7.1179",
    "fi": "static-7.1179",
    "fr-ca": "static-7.1179",
    "fr": "static-7.1179",
    "he-il": "static-7.1179",
    "hi": "static-7.1179",
    "hr": "static-7.1179",
    "hu": "static-7.1179",
    "id": "static-7.1179",
    "it": "static-7.1179",
    "ja": "static-7.1179",
    "ko": "static-7.1179",
    "lt": "static-7.1179",
    "ms": "static-7.1179",
    "nl": "static-7.1179",
    "no": "static-7.1179",
    "pl": "static-7.1179",
    "pt-br": "static-7.1179",
    "pt-pt": "static-7.1179",
    "ro": "static-7.1179",
    "ru": "static-7.1179",
    "sk": "static-7.1179",
    "sl": "static-7.1179",
    "sv": "static-7.1179",
    "th": "static-7.1179",
    "tl": "static-7.1179",
    "tr": "static-7.1179",
    "uk": "static-7.1179",
    "vi": "static-7.1179",
    "x-pseudo": "static-7.1179",
    "zh-cn": "static-7.1179",
    "zh-hk": "static-7.1179",
    "zh-tw": "static-7.1179"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:et', {version: 'static-7.1179'}); }
})();


